import React, { HTMLAttributes } from "react"
import { getPhoneIcon } from "assets/helper/icons"
import { useGeneralSettings } from "hooks/useGeneralSettings"
import { formatPhoneNumber } from "assets/helper/formatPhoneNumber"

type AnchorWithoutClassAndHref = Omit<HTMLAnchorElement, "href" | "className">

interface AnchorNumberProps extends HTMLAttributes<AnchorWithoutClassAndHref> {
  phoneNumber?: string
  trackingNumber?: string
  label?: string
  svgIcon?: string
  classNameModifier?: string
  extraClassNames?: string
  showIcon?: boolean
  baseClassName: string
}

export const AnchorNumber = ({
  baseClassName,
  phoneNumber,
  trackingNumber,
  label,
  svgIcon,
  classNameModifier = "",
  extraClassNames = "",
  showIcon = true,
  ...rest
}: AnchorNumberProps) => {
  const { usePhoneNumberNotTrackingNumber } = useGeneralSettings()
  const contactNumber = usePhoneNumberNotTrackingNumber
    ? phoneNumber
    : trackingNumber
  return (
    <a
      href={`tel: ${contactNumber}`}
      className={`${baseClassName}${classNameModifier} ${extraClassNames}`}
      {...rest}
    >
      {label && (
        <div className={`${baseClassName}${classNameModifier}__label`}>
          {label}
        </div>
      )}
      {showIcon && svgIcon && (
        <span
          dangerouslySetInnerHTML={{ __html: svgIcon }}
          contentEditable="false"
          className="phone-svg-container"
        />
      )}
      {showIcon && !svgIcon && <>{getPhoneIcon()}</>}
      <h5 className={`${baseClassName}${classNameModifier}__number`}>
        {contactNumber && formatPhoneNumber(contactNumber)}
      </h5>
    </a>
  )
}
